import { useMemo } from 'react';
import apiClient from 'src/api/axiosClient';
import { Automation, AutomationSaveRequestData, GetAutomationsParams } from '../types';

export function useAutomationsApi() {
  return useMemo(
    () => ({
      getAutomations: (params: GetAutomationsParams) => {
        return apiClient.get<{ items: Automation[]; count: number }>(`/automations`, { params });
      },

      createAutomation: (params: { companyId: string }, data: AutomationSaveRequestData) => {
        return apiClient.post<Automation>(`/automations`, data, { params });
      },

      updateAutomation: (
        automationId: string,
        params: { companyId: string },
        data: AutomationSaveRequestData,
      ) => {
        return apiClient.put<Automation>(`/automations/${automationId}`, data, { params });
      },

      deleteAutomation: (automationId: string, params: { companyId: string }) => {
        return apiClient.delete<void>(`/automations/${automationId}`, { params });
      },
    }),
    [],
  );
}
